import { Home, Building2, Check, ArrowRight, FileText } from "lucide-react";
import { scrollToId } from "../data/site";
import { FadeUp, SectionHead } from "./motion";
import { useLang } from "../context/LangContext";

export const Clients = () => {
  const { S } = useLang();
  const C = S.clients;
  const go = (e) => {
    e.preventDefault();
    scrollToId("#devis");
  };

  return (
    <section id="clients" data-testid="clients-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow={C.eyebrow}
          title={C.title}
          subtitle={C.subtitle}
        />

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <FadeUp>
            <article
              data-testid="card-particuliers"
              className="h-full rounded-3xl border border-slate-200 bg-slate-50 p-10 lg:p-12 transition-all duration-500 hover:border-sky-300 hover:shadow-2xl hover:shadow-sky-100"
            >
              <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-sky-600 text-white shadow-lg shadow-sky-600/30">
                <Home className="w-7 h-7" />
              </span>
              <h3 className="mt-8 font-display text-2xl font-bold tracking-tight text-slate-900">{C.part.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{C.part.intro}</p>
              <ul className="mt-8 space-y-4">
                {C.part.bullets.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-slate-700">
                    <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-sky-100 text-sky-700 shrink-0">
                      <Check className="w-3 h-3" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <a
                href="#devis"
                onClick={go}
                data-testid="particuliers-cta"
                className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold text-sky-600 hover:text-sky-700 transition-colors"
              >
                {C.part.cta}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </article>
          </FadeUp>

          <FadeUp delay={0.12}>
            <article
              data-testid="card-professionnels"
              className="relative h-full overflow-hidden rounded-3xl bg-[#0A182E] p-10 lg:p-12 grain transition-all duration-500 hover:shadow-2xl hover:shadow-slate-900/30"
            >
              <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-sky-600/15 blur-3xl" aria-hidden="true" />
              <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/10 text-sky-400 border border-white/10">
                <Building2 className="w-7 h-7" />
              </span>
              <h3 className="relative mt-8 font-display text-2xl font-bold tracking-tight text-white">{C.pro.title}</h3>
              <p className="relative mt-3 text-sm leading-relaxed text-slate-300">{C.pro.intro}</p>
              <ul className="relative mt-8 space-y-4">
                {C.pro.bullets.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-slate-200">
                    <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-sky-500/20 text-sky-400 shrink-0">
                      <Check className="w-3 h-3" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="relative mt-10 flex flex-wrap items-center gap-5">
                <a
                  href="#devis"
                  onClick={go}
                  data-testid="professionnels-cta"
                  className="group inline-flex items-center gap-2 rounded-full bg-sky-600 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-sky-500"
                >
                  {C.pro.cta}
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
                <span className="inline-flex items-center gap-2 text-xs text-slate-400">
                  <FileText className="w-4 h-4 text-sky-400" />
                  {C.pro.note}
                </span>
              </div>
            </article>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
